<template>
  <div class="modal--password">
    <div class="modalCustom__header">
      <h5 class="">{{ $t('reset_password') }}</h5>
      <hr class="modalCustom__header-border" />
    </div>

    <div class="modalCustom__body">
      <VuePassword @update:field="setPassword($event)" size="11" auto="true" characters="a-z,A-Z,0-9"> </VuePassword>

      <div v-if="catchedErrors" v-for="error in catchedErrors" v-bind:key="error">
        <p class="pt-3 text-custom_red text-xs">{{ error }}</p>
      </div>
    </div>

    <div class="modalCustom__footer">
      <div class="mr-3">
        <p-button type="danger" round @click.native.prevent="closeModal">
          {{ $t('Cancel') }}
        </p-button>
      </div>
      <div v-if="this.password === this.confirm_password">
        <p-button type="success" round @click.native.prevent="updatePassword">
          {{ $t('save') }}
        </p-button>
      </div>
      <div v-else>
        <p-button type="success" :disabled="true" round>
          {{ $t('save') }}
        </p-button>
      </div>
    </div>
  </div>
</template>

<script>
import VuePassword from '../VuePassword';
import axiosAuth from '../../axiosMain';
import CancelButton from '../buttons/CancelButton';
import SaveButton from '../buttons/SaveButton';
export default {
  name: 'PasswordModal',
  components: {
    SaveButton,
    CancelButton,
    VuePassword,
  },
  props: ['data'],
  data: function () {
    return {
      password: null,
      confirm_password: null,
      hasErrors: true,
      catchedErrors: null,
    };
  },
  methods: {
    setPassword: function (event) {
      this.catchedErrors = null;
      this.password = event.password;
      this.confirm_password = event.confirm_password;
    },
    closeModal: function () {
      this.$emit('close');
    },
    updatePassword: function () {
      axiosAuth
        .patch(
          '/credentials/' + this.data.credential.data.credential_id,
          {
            password: this.password,
            password_confirmation: this.confirm_password,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.closeModal();
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('password_was_updated'),
          });
        })
        .catch((errors) => {
          this.catchedErrors = errors.response.data.password;
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data.password[0],
          });
        });
    },
  },
};
</script>

<style scoped></style>
